module.exports = __webpack_public_path__ + "static/media/Ex3-S2-AV-3.703bcfae.PNG";